import { Send, Trash2 } from 'lucide-react';

export const formatTimer = (seconds) =>
  `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;

/**
 * The recording row that replaces the text input: trash, pulsing red dot with the timer, send.
 * @param {{seconds: number, busy?: boolean, onCancel: () => void, onSend: () => void}} props
 */
const VoiceRecorderBar = ({ seconds, busy = false, onCancel, onSend }) => (
  <div className="flex items-center gap-3">
    <button
      type="button"
      aria-label="Cancel recording"
      disabled={busy}
      onClick={onCancel}
      className="shrink-0 p-2 text-gray-600 disabled:opacity-40"
    >
      <Trash2 size={20} />
    </button>
    <div className="flex flex-1 items-center gap-2 text-sm text-gray-700">
      <span aria-hidden="true" className="h-2.5 w-2.5 animate-pulse rounded-full bg-red-500" />
      <span aria-label="Recording time">{busy ? 'Sending...' : formatTimer(seconds)}</span>
    </div>
    <button
      type="button"
      aria-label="Send voice note"
      disabled={busy}
      onClick={onSend}
      className="shrink-0 rounded-full bg-[#008069] p-2 text-white disabled:opacity-40"
    >
      <Send size={18} />
    </button>
  </div>
);

export default VoiceRecorderBar;
